<div class="cta-section card border-0 p-4">
    <div class="card-details">
        <h2 class="card-title">Looking to Boost Your Brand's Visibility?</h2>
        <p class="card-text">
            "Launch your branded app on the App Store and Google Play. Contact us
            at <a href="mailto:info@activitypro.app">info&#64;activitypro.app</a>!
        </p>
    </div>

    <p-galleria [value]="screenshots" [numVisible]="1" [circular]="true" [showItemNavigators]="true"
        [showItemNavigatorsOnHover]="true" [showThumbnails]="false" [autoPlay]="true" [transitionInterval]="3000"
        (onItemChange)="onScreenshotChange($event)">
        <ng-template pTemplate="item" let-screenshot>
            <img [src]="'../../../../assets/img/cta_screenshots/' + screenshot" style="width: 100%; display: block" />
        </ng-template>
    </p-galleria>
</div>